<template>
  <BootstrapDialog
    title="缴费记录"
    ref="dialog"
    size="lg"
    @afterClose="afterClose()"
  >
    <template v-slot:body>
      <div class="modal-body wrapper-lg" style="width:100%">
        <div class="modal-body wrapper-lg" style="width:100%">
          <div class="row">
            <div class="col-sm-10 col-sm-offset-1">
              <form role="form">
                <div class="form-group">
                  <label><span style="color: red"></span>套餐名称：</label>
                  <span>{{ model.tcmc }}</span>
                </div>

                <div class="form-group">
                  <label><span style="color: red"></span>收费项目：</label>
                  <div v-if="sfbzList.length != 0">
                    <table
                      width="100%"
                      class="table xunw_table_form"
                      border="0"
                    >
                      <thead>
                        <tr>
                          <th width="30%" align="center">名称</th>
                          <th width="20%" align="center">金额</th>
                          <th width="20%" align="center">缴费状态</th>
                          <th width="20%" align="center">备注</th>
                        </tr>
                      </thead>
                      <tbody v-for="(sfbz, i) in sfbzList" :key="i">
                        <!-- 收费项 -->
                        <tr>
                          <th width="30%" align="center">{{ sfbz.sflx }}</th>
                          <td width="20%" align="center">{{ sfbz.sfje }}元</td>
                          <td width="20% " align="center">
                            {{ sfbz.ispayed ? "已缴费" : "未缴费" }}
                          </td>
                          <td width="20%" align="center">
                            <a
                              href="javascript:void(0)"
                              v-if="!sfbz.ispayed"
                              @click="toPay(sfbz)"
                              >线下缴费</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button
        style="margin-left:10px"
        class="btn btn-default"
        type="button"
        @click="close()"
      >
        关闭
      </button>
    </template>
  </BootstrapDialog>
</template>
<script>
export default {
  name: "StudentFeeView",
  components: {},
  data: function() {
    return {
      model: {
        tcmc: "",
      },
      sfbzList: [],
      zcId: "",
    };
  },
  created() {},
  methods: {
    toPay(item) {
      let obj = {
        zcId: this.zcId,
        tcId: item.tc_id,
        sfbzId: item.id,
      };
      this.$http.post("/htgl/biz/cw/tc/offlinePay", obj).then((res) => {
        if (res.data) {
          this.$success("操作成功");
          this.getPayInfo(this.zcId);
        }
      });
    },
    reset: function() {
      this.model = {
        tcmc: "",
      };
      this.sfbzList = [];
      this.zcId = "";
    },

    open(row) {
      this.zcId = row.zcid;
      this.getPayInfo(row.zcid);

      this.$refs.dialog.open();
    },
    getPayInfo(zcId) {
      this.$http
        .post("/htgl/biz/cw/tc/offlinePayInfo", { zcId: zcId })
        .then((res) => {
          if (res.data) {
            this.sfbzList = res.data.sfbzList || [];
            this.model.tcmc = res.data.tcmc;
          }
        });
    },
    close: function() {
      this.$refs.dialog.close();
    },
    afterClose: function() {
      this.$validator.reset();
      this.reset();
    },
  },
};
</script>
